/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { create } from '../fn/form-signature/create';
import { Create$Params } from '../fn/form-signature/create';
import { FormSignature } from '../models/form-signature';
import { FormSignatureCreateResponseDto } from '../models/form-signature-create-response-dto';
import { listAll } from '../fn/form-signature/list-all';
import { ListAll$Params } from '../fn/form-signature/list-all';

@Injectable({ providedIn: 'root' })
export class FormSignatureService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formSignatureControllerListAll()` */
  static readonly FormSignatureControllerListAllPath = '/forms/{formId}/signatures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAll$Response(
    params: ListAll$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormSignature>>> {
    return listAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAll(params: ListAll$Params, context?: HttpContext): Observable<Array<FormSignature>> {
    return this.listAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormSignature>>): Array<FormSignature> => r.body)
    );
  }

  /** Path part for operation `formSignatureControllerCreate()` */
  static readonly FormSignatureControllerCreatePath = '/forms/{formId}/signatures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(
    params: Create$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormSignatureCreateResponseDto>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<FormSignatureCreateResponseDto> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormSignatureCreateResponseDto>): FormSignatureCreateResponseDto => r.body)
    );
  }
}
